import Overlay from './customOverlay';

export default function NoRowsOverlay() {
  return <Overlay title="Brak pozycji" />;
}
